<template>
  <div class="search-drawer-details">
    <div class="form__container">
      <i-form class="form" :label-width="120">
        <template v-if="type === 'residence'">
          <i-form-item label="物件種別">
            <i-checkbox-group v-model="search.m_b_type">
              <i-checkbox v-for="(item, idx) in selResidence" :label="item.value" :key="`selResidence${idx}`">
                {{ item.label }}
              </i-checkbox>
            </i-checkbox-group>
          </i-form-item>
        </template>

        <template v-if="type === 'investment'">
          <i-form-item label="物件種別">
            <div class="m_b_type" style="display: flex; align-items: flex-start;">
              <span class="m_b_type__label">建物全部</span>
              <i-checkbox-group v-model="search.m_b_type">
                <i-checkbox v-for="(item, idx) in selWhole" :label="item.value" :key="`selWhole${idx}`">
                  {{ item.label }}
                </i-checkbox>
              </i-checkbox-group>
            </div>
            <div class="m_b_type">
              <span class="label">建物一部</span>
              <i-checkbox-group v-model="search.m_b_type">
                <i-checkbox v-for="(item, idx) in selPartBuilding" :label="item.value" :key="`selPartBuilding${idx}`">
                  {{ item.label }}
                </i-checkbox>
              </i-checkbox-group>
            </div>
          </i-form-item>
        </template>

        <i-form-item label="販売状態">
          <i-select v-model="search.mi_sale_state" size="small" placeholder clearable filterable style="width:160px;">
            <i-option v-for="(item, idx) in master.sale_state" :value="item.cd" :key="idx">{{ item.label }}</i-option>
          </i-select>
        </i-form-item>

        <i-form-item label="現況">
          <i-select v-model="search.m_vacant_type" size="small" placeholder clearable filterable style="width:160px;">
            <i-option v-for="(item, idx) in selMVacantType" :value="item.cd" :key="idx">{{ item.label }}</i-option>
          </i-select>
        </i-form-item>

        <template v-if="type === 'investment'">
          <i-form-item label="オーナーチェンジ">
            <i-checkbox v-model="search.f_owner_change" :true-value="1" :false-value="0">
              有
            </i-checkbox>
          </i-form-item>
        </template>

        <i-form-item label="物件価格">
          <i-input v-model="search.b_price_from" style="width: 80px;" placeholder clearable filterable size="small" />
          <span class="form__text">万円</span>
          <span class="form__text">〜</span>
          <i-input v-model="search.b_price_to" style="width: 80px;" placeholder clearable filterable size="small" />
          <span class="form__text">万円</span>
        </i-form-item>

        <template v-if="type === 'investment'">
          <i-form-item label="満室時利回り">
            <i-input v-model="search.yield_from" style="width: 80px;" placeholder clearable filterable size="small" />
            <span class="form__text">%</span>
            <span class="form__text">〜</span>
            <i-input v-model="search.yield_to" style="width: 80px;" placeholder clearable filterable size="small" />
            <span class="form__text">%</span>
          </i-form-item>
        </template>

        <template v-if="type === 'investment'">
          <i-form-item label="満室時年間収入">
            <i-input
              v-model="search.income_price_from"
              style="width: 80px;"
              placeholder
              clearable
              filterable
              size="small"
            />
            <span class="form__text">万円</span>
            <span class="form__text">〜</span>
            <i-input
              v-model="search.income_price_to"
              style="width: 80px;"
              placeholder
              clearable
              filterable
              size="small"
            />
            <span class="form__text">万円</span>
          </i-form-item>
        </template>

        <template v-if="type === 'investment'">
          <i-form-item label="倍率（軍用地)">
            <i-input
              v-model="search.magnification_from"
              style="width: 80px;"
              placeholder
              clearable
              filterable
              size="small"
            />
            倍
            <span class="form__text">〜</span>
            <i-input
              v-model="search.magnification_to"
              style="width: 80px;"
              placeholder
              clearable
              filterable
              size="small"
            />
            <span class="form__text">倍</span>
          </i-form-item>
        </template>

        <i-form-item label="沿線・駅">
          <i-row>
            <i-col span="24">
              <span class="form__text label">沿線名1</span>
              <i-select
                v-model="search.line_1_cd_name"
                size="small"
                :loading="stationLoading"
                loading-text="沿線データ取得中"
                @on-change="onChangeLineSelect1"
                placeholder
                filterable
                clearable
                not-found-text
                style="width:100px;"
              >
                <i-option v-for="(item, itemIdx) in lines" :value="item.line_cd + '_' + item.line_name" :key="itemIdx">
                  {{ item.line_name }}
                </i-option>
              </i-select>
              <span class="form__text label">駅名1</span>
              <i-select
                v-model="search.station_1"
                size="small"
                placeholder
                filterable
                clearable
                :disabled="station_1.length === 0"
                style="width:100px;"
              >
                <i-option v-for="item in station_1" :value="`${item.station_cd}`" :key="`${item.station_cd}`">{{
                  item.station_name
                }}</i-option>
              </i-select>
              <span class="form__text">〜</span>

              <i-select
                v-model="search.station_end_1"
                size="small"
                placeholder
                filterable
                clearable
                :disabled="station_1.length === 0"
                style="width:100px;"
              >
                <i-option v-for="item in station_1" :value="`${item.station_cd}`" :key="`${item.station_cd}`">{{
                  item.station_name
                }}</i-option>
              </i-select>
            </i-col>
            <i-col span="24">
              <span class="form__text label">沿線名2</span>
              <i-select
                v-model="search.line_2_cd_name"
                size="small"
                :loading="stationLoading"
                loading-text="沿線データ取得中"
                placeholder
                filterable
                clearable
                not-found-text
                @on-change="onChangeLineSelect2"
                style="width:100px;"
              >
                <i-option v-for="(item, itemIdx) in lines" :value="item.line_cd + '_' + item.line_name" :key="itemIdx">
                  {{ item.line_name }}
                </i-option>
              </i-select>
              <span class="form__text label">駅名2</span>
              <i-select
                v-model="search.station_2"
                size="small"
                placeholder
                filterable
                clearable
                :disabled="station_2.length === 0"
                style="width:100px;"
              >
                <i-option v-for="item in station_2" :value="`${item.station_cd}`" :key="`${item.station_cd}`">{{
                  item.station_name
                }}</i-option>
              </i-select>
              <span class="form__text">〜</span>
              <i-select
                v-model="search.station_end_2"
                placeholder
                size="small"
                filterable
                clearable
                :disabled="station_2.length === 0"
                style="width:100px;"
              >
                <i-option v-for="item in station_2" :value="`${item.station_cd}`" :key="`${item.station_cd}`">{{
                  item.station_name
                }}</i-option>
              </i-select>
            </i-col>
            <i-col span="24">
              <span class="form__text label">沿線名3</span>
              <i-select
                v-model="search.line_3_cd_name"
                size="small"
                :loading="stationLoading"
                loading-text="沿線データ取得中"
                placeholder
                filterable
                clearable
                not-found-text
                @on-change="onChangeLineSelect3"
                style="width:100px;"
              >
                <i-option v-for="(item, itemIdx) in lines" :value="item.line_cd + '_' + item.line_name" :key="itemIdx">
                  {{ item.line_name }}
                </i-option>
              </i-select>
              <span class="form__text label">駅名3</span>
              <i-select
                v-model="search.station_3"
                size="small"
                placeholder
                filterable
                clearable
                :disabled="station_3.length === 0"
                style="width:100px;"
              >
                <i-option v-for="item in station_3" :value="`${item.station_cd}`" :key="`${item.station_cd}`">{{
                  item.station_name
                }}</i-option>
              </i-select>
              <span class="form__text">〜</span>
              <i-select
                v-model="search.station_end_3"
                size="small"
                placeholder
                filterable
                clearable
                :disabled="station_3.length === 0"
                style="width:100px;"
              >
                <i-option v-for="item in station_3" :value="`${item.station_cd}`" :key="`${item.station_cd}`">{{
                  item.station_name
                }}</i-option>
              </i-select>
            </i-col>
            <i-col span="24">
              <p class="station_notice">
                ※沿線名だけでも検索可能です。駅名のみで検索する場合は、最上部にある「駅名」のテキストボックスをご利用ください。
              </p>
            </i-col>
          </i-row>
        </i-form-item>

        <i-form-item label="駅徒歩">
          <i-select
            v-model="search.walk_minutes_from"
            size="small"
            placeholder
            filterable
            clearable
            style="width:50px;"
          >
            <i-option v-for="item in selWalkMinutes" :value="item" :key="item">{{ item }}</i-option>
          </i-select>
          <span class="form__text">〜</span>
          <i-select v-model="search.walk_minutes_to" size="small" placeholder filterable clearable style="width:50px;">
            <i-option v-for="item in selWalkMinutes" :value="item" :key="item">{{ item }}</i-option>
          </i-select>
          <span class="form__text">分以内</span>
        </i-form-item>

        <i-form-item label="バス停名">
          <i-input size="small" v-model="search.bus_stop" placeholder style="width: 240px;" />
        </i-form-item>

        <i-form-item label="ライフライン">
          <div class="lifeline">
            <span class="lifeline__label">上水道</span>
            <i-checkbox-group v-model="search.water_supply_type" class="lifeline__item">
              <i-checkbox v-for="(item, idx) in master.water_supply_type" :key="idx" :label="item.cd">
                {{ item.label }}
              </i-checkbox>
            </i-checkbox-group>
          </div>
          <div class="lifeline">
            <span class="lifeline__label">下水道</span>
            <i-checkbox-group v-model="search.sewerage_type" class="lifeline__item">
              <i-checkbox v-for="(item, idx) in master.sewerage_type" :key="idx" :label="item.cd">
                {{ item.label }}
              </i-checkbox>
            </i-checkbox-group>
          </div>
          <div class="lifeline">
            <span class="lifeline__label">ガス</span>
            <i-checkbox-group v-model="search.gas_type" class="lifeline__item">
              <i-checkbox v-for="(item, idx) in master.gas_type" :key="idx" :label="item.cd">
                {{ item.label }}
              </i-checkbox>
            </i-checkbox-group>
          </div>
          <div class="lifeline">
            <span class="lifeline__label">電気</span>
            <i-checkbox v-model="search.f_power_source" :true-value="1" :false-value="0">
              動力電源
            </i-checkbox>
            <i-checkbox v-model="search.f_electricity" :true-value="1" :false-value="0">
              電気
            </i-checkbox>
            <i-checkbox v-model="search.f_all_electrification" :true-value="1" :false-value="0">
              オール電化
            </i-checkbox>
          </div>
        </i-form-item>

        <i-form-item label="ランク">
          <i-checkbox-group v-model="search.rank">
            <i-checkbox v-for="(item, idx) in master.rank" :key="idx" :label="item.cd">
              {{ item.label }}
            </i-checkbox>
          </i-checkbox-group>
        </i-form-item>

        <i-form-item label="マーク">
          <i-checkbox-group v-model="search.list_star">
            <template v-for="(item, idx) in selListStar">
              <i-checkbox v-if="item.show" :key="idx" :label="item.value">
                {{ item.label }}
              </i-checkbox>
            </template>
          </i-checkbox-group>
        </i-form-item>

        <i-form-item label="取引形態">
          <i-checkbox-group v-model="search.transaction_form">
            <i-checkbox v-for="(item, idx) in master.transaction_form" :key="idx" :label="item.cd">
              {{ item.label }}
            </i-checkbox>
          </i-checkbox-group>
        </i-form-item>

        <i-form-item label="元付業者名">
          <i-input v-model="search.eacompany_name" size="small" placeholder style="width: 160px;" />
        </i-form-item>

        <i-form-item label="元付業者TEL">
          <i-input v-model="search.eacompany_tel" size="small" placeholder style="width: 160px;" />
        </i-form-item>

        <i-form-item label="元付業者ID">
          <i-input v-model="search.eacompany_id" size="small" placeholder style="width: 160px;" />
        </i-form-item>

        <i-form-item label="画像数">
          <i-select v-model="search.image_num_from" size="small" placeholder filterable clearable style="width:50px;">
            <i-option v-for="item in selImageNum" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          枚
          <span class="form__text">〜</span>
          <i-select v-model="search.image_num_to" size="small" placeholder filterable clearable style="width:50px;">
            <i-option v-for="item in selImageNum" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">枚</span>
        </i-form-item>

        <i-form-item label="パノラマ画像数" class="form-item__panorama">
          <i-select
            v-model="search.panorama_num_from"
            size="small"
            style="width:50px;"
            placeholder
            filterable
            clearable
          >
            <i-option v-for="item in selPanoramaNum" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">枚</span>
          <span class="form__text">〜</span>
          <i-select v-model="search.panorama_num_to" size="small" style="width:50px;" placeholder filterable clearable>
            <i-option v-for="item in selPanoramaNum" :key="item" :value="item">
              {{ item }}
            </i-option>
          </i-select>
          <span class="form__text">枚</span>
        </i-form-item>

        <i-form-item label="動画URL">
          <i-checkbox v-model="search.f_video_url" :true-value="1" :false-value="0">
            有
          </i-checkbox>
        </i-form-item>

        <i-form-item label="担当者1">
          <i-input v-model="search.charge_person" size="small" placeholder filterable clearable style="width: 200px;" />
        </i-form-item>

        <i-form-item label="掲載用担当者">
          <i-input v-model="search.listing_charge_person" size="small" placeholder filterable clearable style="width: 200px;" />
        </i-form-item>

        <i-form-item label="作成日">
          <InputDatePicker :from.sync="search.created_at_from" :to.sync="search.created_at_to" />
        </i-form-item>
        <i-form-item label="更新日">
          <InputDatePicker :from.sync="search.updated_at_from" :to.sync="search.updated_at_to" />
        </i-form-item>

        <i-form-item label="最終編集者">
          <i-select
            v-model="search.last_updated_person"
            size="small"
            placeholder
            filterable
            clearable
            style="width:160px;"
          >
            <template v-for="(item, idx) in selLastUpdatedPerson">
              <i-option :key="`selLastUpdatedPerson${idx}`" :value="item.id">{{ item.name }}</i-option>
            </template>
          </i-select>
        </i-form-item>

        <i-form-item label="担当店舗">
          <i-select
            v-model="search.room_charge_shop_list"
            size="small"
            placeholder
            filterable
            multiple
            :max-tag-count="1"
            style="width:240px;"
          >
            <template v-for="item in chargeShopList">
              <i-option :key="`chargeShopList${item.id}`" :value="item.id">{{ item.name }}</i-option>
            </template>
          </i-select>
        </i-form-item>

        <i-form-item label="イベントコメント">
          <i-checkbox v-model="search.f_event_comment" :true-value="1" :false-value="0">
            有
          </i-checkbox>
        </i-form-item>

        <i-form-item label="フリータグ">
          <i-row type="flex" align="middle" class="freetag">
            <i-col span="24">
              <i-radio-group v-model="search.total_freetag_search_type">
                <i-radio :label="Number(1)">AND</i-radio>
                <i-radio :label="Number(2)">OR</i-radio>
              </i-radio-group>
              <span class="freetag__notice">
                ※フリータグ1～5に入力された情報の検索方式の切り替えを行います。
              </span>
            </i-col>
            <template v-for="n in 5">
              <i-col span="24" :key="`freetag${n}`">
                <i-row type="flex" align="middle">
                  <i-col span="4">
                    <span class="freetag__label">フリータグ{{ n }}</span>
                  </i-col>
                  <i-col span="6" class="freetag__input">
                    <i-input v-model="search[`freetag_search_word_${n}`]" size="small" placeholder></i-input>
                  </i-col>
                  <i-col span="14">
                    <i-radio-group v-model="search[`freetag_search_type_${n}`]">
                      <i-radio :label="Number(1)">完全一致</i-radio>
                      <i-radio :label="Number(2)">前方一致</i-radio>
                      <i-radio :label="Number(3)">含まない</i-radio>
                      <i-radio :label="Number(4)">空</i-radio>
                    </i-radio-group>
                  </i-col>
                </i-row>
              </i-col>
            </template>
          </i-row>
        </i-form-item>
        <i-form-item label="小学校">
          <i-input v-model="search.elementary_school" size="small" placeholder clearable style="width: 200px;" />
        </i-form-item>
        <i-form-item label="中学校">
          <i-input v-model="search.junior_high_school" size="small" placeholder clearable style="width: 200px;" />
        </i-form-item>
      </i-form>
    </div>
  </div>
</template>

<script>
import MBType from '@/constants/m_b_type.js'
import InputDatePicker from '@/components/parts/InputDatePicker'
import TrainRepository from '@/repositories/trainRepository'
import ShopRepository from '@/repositories/shopRepository'
import UserRepository from '@/repositories/userRepository'
import { residenceList, wholeList, partBuildingList } from '@/util/m_b_type.js'
import {
  Row,
  Col,
  Input,
  Form,
  FormItem,
  CheckboxGroup,
  Checkbox,
  Select,
  Option,
  RadioGroup,
  Radio,
} from 'view-design'
export default {
  components: {
    'i-row': Row,
    'i-col': Col,
    'i-input': Input,
    'i-form': Form,
    'i-form-item': FormItem,
    'i-checkbox-group': CheckboxGroup,
    'i-checkbox': Checkbox,
    'i-select': Select,
    'i-option': Option,
    'i-radio-group': RadioGroup,
    'i-radio': Radio,
    InputDatePicker,
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      MBType: MBType,
      lines: [],
      stationLoading: false,
      selWalkMinutes: [],
      station_1: [],
      station_2: [],
      station_3: [],
      selImageNum: [],
      selPanoramaNum: [],
      year: [],
      month: [],
      day: [],
      selLastUpdatedPerson: [],
      chargeShopList: [],
    }
  },
  computed: {
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    master() {
      return this.$store.getters['Master/getMaster']
    },
    user() {
      return this.$store.getters['User/getUser']
    },
    selListStar() {
      return this.user && this.user.list_star ? this.user.list_star : []
    },
    selMVacantType() {
      return this.master.vacant_type ? this.master.vacant_type.all : []
    },
    // 物件種別 居住用 optionリスト
    selResidence() {
      return residenceList()
    },
    // 物件種別 建物全部 optionリスト
    selWhole() {
      return wholeList()
    },
    // 物件種別 建物一部 optionリスト
    selPartBuilding() {
      return partBuildingList()
    },
  },
  created() {
    // 沿線データ取得
    this.getLine()
    // 店舗データ取得
    this.getShops()
    // 更新者データ取得
    this.getLastUpdatedPerson()
    // Option用 駅徒歩
    for (let i = 1; i <= 99; i++) this.selWalkMinutes.push(String(i))
    // Option用 画像数
    for (let i = 0; i <= 60; i++) this.selImageNum.push(i)
    // Option用 パノラマ画像数
    for (let i = 0; i <= 12; i++) this.selPanoramaNum.push(i)
    // Option用 日付
    const nowYear = new Date().getFullYear()
    for (let i = 2000; i <= nowYear; i++) this.year.push(i)
    this.year = this.year.reverse()
    for (let i = 1; i <= 12; i++) this.month.push(i)
    for (let i = 1; i <= 31; i++) this.day.push(i)
  },
  watch: {},
  methods: {
    // 沿線1 データ変更時の処理
    onChangeLineSelect1(value) {
      this.station_1 = []
      this.search.station_1 = ''
      this.search.station_end_1 = ''
      if (value) {
        this.getStation(value, 1)
      }
    },
    // 沿線2 データ変更時の処理
    onChangeLineSelect2(value) {
      this.station_2 = []
      this.search.station_2 = ''
      this.search.station_end_2 = ''
      if (value) {
        this.getStation(value, 2)
      }
    },
    // 沿線3 データ変更時の処理
    onChangeLineSelect3(value) {
      this.station_3 = []
      this.search.station_3 = ''
      this.search.station_end_3 = ''
      if (value) {
        this.getStation(value, 3)
      }
    },
    // 沿線データを取得
    async getLine() {
      await TrainRepository.getLines([])
        .then(data => {
          if (data.result) {
            // 沿線名をユニークにする処理
            const uniqueLines = _.chain(data.data)
              .groupBy('line_name')
              .map(lines => {
                const firstLine = _.cloneDeep(lines[0])
                // pref_cdとpref_nameを配列にまとめる
                const prefCds = _.map(lines, 'pref_cd')
                const prefNames = _.map(lines, 'pref_name')
                // 複数の値がある場合は配列に、1つだけのときはそのままの値にする
                firstLine.pref_cd = prefCds.length > 1 ? prefCds : firstLine.pref_cd
                firstLine.pref_name = prefNames.length > 1 ? prefNames : firstLine.pref_name

                return firstLine
              })
              .value()
            this.lines = uniqueLines
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {})
    },
    // 駅データを取得
    async getStation(lineCdName, stationNumber) {
      // 沿線コード + 沿線名の分離（ex. lineCdName: 2_101_JR宇都宮線）
      const match = lineCdName.match(/^(\d{1}-\d{3})_(.+)$/)
      let lineCd = ''
      let lineName = ''
      if (match) {
        lineCd = match[1] // ex. 2_101
        lineName = match[2] // ex. JR宇都宮線
      }
      await TrainRepository.getStations([lineCd], [], [lineName])
        .then(data => {
          if (data.result) {
            // 駅名をユニークにする処理
            const uniqueSts = _.chain(data.data)
              .groupBy('station_name')
              .map(lines => {
                const firstLine = _.cloneDeep(lines[0])
                // pref_cdとpref_nameを配列にまとめる
                const prefCds = _.map(lines, 'pref_cd')
                const prefNames = _.map(lines, 'pref_name')
                // 複数の値がある場合は配列に、1つだけのときはそのままの値にする
                firstLine.pref_cd = prefCds.length > 1 ? prefCds : firstLine.pref_cd
                firstLine.pref_name = prefNames.length > 1 ? prefNames : firstLine.pref_name

                return firstLine
              })
              .value()
            this[`station_${stationNumber}`] = uniqueSts
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {})
    },
    // 店舗データを取得
    async getShops() {
      await ShopRepository.get()
        .then(data => {
          if (data.result) {
            this.chargeShopList = data.data
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {})
    },
    // ユーザーデータを取得
    async getLastUpdatedPerson() {
      await UserRepository.getList()
        .then(data => {
          if (data.result) {
            this.selLastUpdatedPerson = data.data
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.search-drawer-details {
  .form {
    &__container {
      height: calc(100vh - 280px);
      overflow: scroll;
    }
    &__text {
      display: inline-block;
      margin: 0 8px;
      &.label {
        width: auto;
      }
    }
  }

  .m_b_type {
    display: flex;
    align-items: flex-start;
    &__label {
      display: inline-block;
      width: 60px;
      font-weight: bold;
      flex: 1 0 auto;
    }
  }

  .lifeline {
    &__label {
      display: inline-block;
      width: 48px;
      margin-right: 4px;
      font-weight: bold;
    }
    &__item {
      display: inline-block;
    }
  }

  .freetag {
    &__notice {
      color: #f00;
    }
    &__label {
      width: 80px;
      font-weight: bold;
    }
    &__input {
      padding-right: 4px;
    }
  }

  .station_notice {
    color: #f00;
    line-height: 1.4;
  }

  .ivu-form-item {
    margin-bottom: 8px;
  }
  .ivu-checkbox {
    margin-right: 4px;
  }

  .form-item__panorama .ivu-form-item-label {
    padding-left: 20px;
  }
}
</style>
